import { diffkyesLambdaInvoke } from "@/utils/LambdaHelper";
import { goToErrorPage } from "@/utils/Other";

export const diffKeysGet = () => {
  return new Promise((resolve) => {
    try {
      diffkyesLambdaInvoke()
        .then((res) => {
          resolve(res.diff_keys || []);
        })
        .catch((error) => {
          goToErrorPage(error);
        });
    } catch (e) {
      goToErrorPage(e);
    }
  });
};

export function showChangeIcon(diffKeys, keyList) {
  for (let key of keyList) {
    if (diffKeys.indexOf(key) > -1) {
      return true;
    }
  }
  return false;
}

export function isChangeNotice(diffKeys, key) {
  return diffKeys.indexOf(key) > -1;
}
